function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.1348 5.83783H53.2699V32.4081H36.0494V40.8649H30.3364V32.8444H23.9148C18.0012 29.7389 20.4343 30.3677 13.141 30.4254V5.83783H13.1348Z",
  fill: "#FDFDFD"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.45911 47.4325H24.8103V35.3352C24.5453 28.2011 1.39748 27.7808 1.45911 36.0756V47.4325Z",
  fill: "#FDFDFD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7713 11.6757C21.0496 11.6757 21.0303 24.0811 12.7713 24.0811C4.51232 24.0811 4.48651 11.6757 12.7713 11.6757Z",
  fill: "#FDFDFD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2313 12.4054C22.5096 12.4054 22.4902 24.8108 14.2313 24.8108C5.97228 24.8108 5.94647 12.4054 14.2313 12.4054Z",
  fill: "#FDFDFD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M53.8798 7.49014C53.8798 31.322 54.9037 33.8796 50.9754 33.8796H36.2613V39.0643C37.9804 39.0643 39.8483 38.7178 39.8483 40.3621C39.8483 42.1827 38.6816 41.6598 26.6423 41.6598C25.6555 41.6598 25.91 39.8203 25.91 47.5878C25.91 49.3076 23.347 49.3076 23.347 47.5878V35.8515C23.347 33.445 20.4364 31.4102 16.9797 31.4102C11.6551 31.4102 2.61319 30.4463 2.61319 35.8515C2.61319 47.8335 3.07863 48.8919 1.33478 48.8919C-0.409063 48.8919 0.0563755 47.6886 0.0563755 35.8452C0.0563755 31.9645 4.06536 28.8021 8.9866 28.8021H16.9859C23.4711 28.8021 24.9481 33.2875 24.9481 32.5693C24.9481 30.8243 24.4888 31.2716 50.9754 31.2716C51.4967 31.2716 51.3167 32.3173 51.3167 7.48384C51.3167 6.95466 53.1909 7.13735 14.6091 7.13735C13.8458 7.13735 14.7643 8.57369 13.7775 9.36745C18.1402 9.77064 21.5659 13.5064 21.5659 18.0296C21.5659 29.558 4.40668 29.5454 4.40668 18.0296C4.40668 13.5001 7.83852 9.77064 12.195 9.36745C11.0966 8.48549 11.6427 4.53557 14.6091 4.53557C51.4284 4.53557 53.8798 3.35123 53.8798 7.48384V7.49014ZM33.6983 39.058C33.6983 32.8402 34.4306 33.8733 31.5077 33.8733C31.5077 40.0912 30.7754 39.058 33.6983 39.058ZM28.9508 33.8733C26.183 33.8733 25.9162 33.9741 25.4383 33.5899C25.7486 34.2954 25.9162 35.0514 25.9162 35.8452C25.9162 40.3872 25.6741 39.058 26.6485 39.058C29.6955 39.058 28.9508 40.2424 28.9508 33.8733ZM19.0029 18.0422C19.0029 9.95963 6.9697 9.97853 6.9697 18.0422C6.9697 26.1058 19.0029 26.131 19.0029 18.0422Z",
  fill: "#1B1B1B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.3553 21.6799C39.3553 25.8159 39.8038 27.7297 38.0166 27.7297C36.1384 27.7297 36.6778 25.4755 36.6778 21.6799C36.6778 20.3826 33.3699 20.6973 31.5502 20.6973C29.1261 20.6973 29.7305 22.0588 29.7305 26.4067C29.7305 28.16 27.0465 28.16 27.0465 26.4067C27.0465 22.1423 26.2991 18.7 30.7963 18.1027C27.2155 15.7329 28.9247 10.2162 33.2074 10.2162C37.4902 10.2162 39.2189 15.7265 35.625 18.1027C37.7761 18.3917 39.3683 19.856 39.3683 21.6864L39.3553 21.6799ZM34.8711 14.5191C34.8711 12.3355 31.5242 12.3227 31.5242 14.5191C31.5242 16.7155 34.8711 16.7027 34.8711 14.5191Z",
  fill: "#1B1B1B"
});

function SvgTraining({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.8f09503f631c8611edc68cbb7dd9a189.svg";
export { ForwardRef as ReactComponent };